export { default as T } from './T';
